@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="meetingRoomScoresByListingsSegments()"
            [centerLabel]="meetingRoomScoresByListingsCenterLabel()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        />
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <app-ice-visuals-dashboard-pie-chart
        [segments]="meetingRoomScoresByListingsSegments()"
        [centerLabel]="meetingRoomScoresByListingsCenterLabel()"
        [valueColumnHeader]="'dashboard.visuals.widgets.meetingRoomScoresByListings.tableLabel' | translate"
        [loading]="dataService.loading()"
        [variant]="pieChartVariantEnum.LARGE"
    />
}
